import React from 'react';
import { usePathname } from './hooks/usePathname';
import App from './App';
import { PricingRoute } from './pages/PricingRoute';
import { BudgetRoute } from './pages/BudgetRoute';

const AppRouter: React.FC = () => {
  const pathname = usePathname();

  if (pathname === '/pricing') {
    return <PricingRoute />;
  }

  if (pathname === '/budget') {
    return <BudgetRoute />;
  }

  return <App />;
};

export default AppRouter;
